/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Button, Flex, Text } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import {
  useSlfExceptionListColumns,
  useSlfExceptionListRows,
} from '../../hooks/shareLinkFilter';
import { DlpPolicyItem, SlfException } from '@Policy/utils/types';
import isEqual from 'lodash/isEqual';
import ExceptionModal from './ExceptionModal';
import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { getEmptyTargetUserGroup } from '@Policy/TemplateConfig/cfg.default';
import { useSlfExceptionStyle } from '../../Components/styles';
import { ExceptionListTable } from '../../Components';

const ExceptionList = () => {
  const { t } = useTranslation();

  const { tableStyleProps } = useSlfExceptionStyle();
  const [isVisible, setIsVisible] = React.useState(false);
  // -1: add, >=0: edit
  const [editIndex, setEditIndex] = React.useState(-1);
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore)<DlpPolicyItem>;
  // get state from store
  const slfExceptionList: SlfException[] = policySelector(
    (s) => s.tmSlfFilters?.slfExceptionList,
    isEqual
  );
  const setTempVars = contextSelector((s) => s.setTempVars);
  const setException = contextSelector((s) => s.setException);
  const deleteException = contextSelector((s) => s.deleteException);
  const setEditExceptionStatus = contextSelector(
    (s) => s.setEditExceptionStatus
  );

  const handleDeleteClick = React.useCallback((index: number) => {
    deleteException(index);
  }, []);
  const handleModalClose = React.useCallback(() => {
    setIsVisible(false);
    // clear tempVars and searchTarget
    const emptyTargetUserGroups = getEmptyTargetUserGroup();
    setTempVars({
      slfExceptionPaths: [],
      targetUserGroups: emptyTargetUserGroups,
      searchTargetUserGroups: [],
    });
  }, []);
  const handleAddClick = React.useCallback(() => {
    const emptyTargetUserGroups = getEmptyTargetUserGroup();
    setTempVars({
      slfExceptionPaths: [],
      targetUserGroups: emptyTargetUserGroups,
    });
    setEditIndex(-1);
    setIsVisible(true);
  }, []);
  const handleEditClick = React.useCallback(
    (index: number) => {
      setEditIndex(index);
      setEditExceptionStatus(index);
      setIsVisible(true);
    },
    [slfExceptionList]
  );

  const handleModalSave = React.useCallback((index: number) => {
    console.log('save', index);
    // set tempVars to slfExcetpionList
    setException(index);
  }, []);

  const { slfExceptionListColumns } = useSlfExceptionListColumns(
    handleEditClick,
    handleDeleteClick
  );
  const { slfExceptionListRows } = useSlfExceptionListRows(
    slfExceptionListColumns
  );
  return (
    <>
      <Flex direction="column">
        <Text>{t('policy.text.shareLink.exceptions')}</Text>
        <Button mt="10px" mb="10px" width="50px" onClick={handleAddClick}>
          Add
        </Button>
        <Flex height="1000px" width="800px">
          <ExceptionListTable
            tableStyle={tableStyleProps}
            columns={slfExceptionListColumns}
            rows={slfExceptionListRows}
          />
        </Flex>
      </Flex>
      <ExceptionModal
        editIndex={editIndex}
        isVisible={isVisible}
        onClose={handleModalClose}
        saveConfig={handleModalSave}
      />
    </>
  );
};

export default ExceptionList;
